module.exports = __webpack_public_path__ + "static/panda-00ab879c485e8cd39b56d3ace8c18d12.png";